import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const DynamicBreadcrumbs = ({feature}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sector, subsector, subsubsector } = location.state || {};
  const baseLinkStyle = {
    color: 'rgb(90,130,249)',
    textDecoration: 'none',
    cursor: 'pointer',
  };

  const activeStyle = {
    color: '#000',
    fontWeight: 'bold',
  };

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-3">
        {/* Explore Breadcrumb */}
        <li
          className={`breadcrumb-item ${!sector ? 'active' : ''}`}
          aria-current={!sector ? 'page' : undefined}
        >
          {!sector ? (
            <span style={activeStyle}>Home</span>
          ) : (
            <a
              href="/"
              style={baseLinkStyle}
              onClick={(e) => {
                e.preventDefault();
                navigate('/', { state: {} });
              }}
            >
              Home
            </a>
          )}
        </li>

        {/* Sector Breadcrumb */}
        {sector && (
          <li
            className={`breadcrumb-item ${!subsector ? 'active' : ''}`}
            aria-current={!subsector ? 'page' : undefined}
          >
            {!subsector ? (
              <span style={activeStyle}>
                {sector?.name || 'Sector'}
              </span>
            ) : (
              <span
                style={baseLinkStyle}
                onClick={() =>
                  navigate(`/sector/${sector?.code}`, {
                    state: { sector },
                  })
                }
              >
                {sector?.name || 'Sector'}
              </span>
            )}
          </li>
        )}

        {/* Subsector Breadcrumb */}
        {subsector && (
          <li
            className={`breadcrumb-item ${!subsubsector ? 'active' : ''}`}
            aria-current={!subsubsector ? 'page' : undefined}
          >
            {!subsubsector ? (
              <span style={activeStyle}>
                {subsector?.name || 'Subsector'}
              </span>
            ) : (
              <span
                style={baseLinkStyle}
                onClick={() =>
                  navigate(`/sector/subsector/${subsector?.code}`, {
                    state: { sector, subsector },
                  })
                }
              >
                {subsector?.name || 'Subsector'}
              </span>
            )}
          </li>
        )}

        {/* SubSubsector Breadcrumb */}
        {subsubsector && (
          <li className="breadcrumb-item active" aria-current="page">
            <span style={activeStyle}>
              {subsubsector?.name || 'SubSubsector'}
            </span>
          </li>
        )}
        {feature?.state && (
    <li className="breadcrumb-item">
      <span>{feature.state}</span>
    </li>
  )}

  {feature?.district && (
    <li className="breadcrumb-item active" aria-current="page">
      <span style={activeStyle}>{feature.district}</span>
    </li>
  )}
        
      </ol>
    </nav>
  );
};

export default DynamicBreadcrumbs;
